import React from 'react'
import PropTypes from 'prop-types'
import LinkedIn from '@mui/icons-material/LinkedIn'

const LinkedInIcon = ({ height, width, ...more }) => {
	
	return (
		<LinkedIn
			height={height}
			width={width}
			{...more}
		/>
	)
}

LinkedInIcon.propTypes = {
	height: PropTypes.number.isRequired,
	width: PropTypes.number.isRequired
}

export default LinkedInIcon
